import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../../ui/layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  root: {
    padding: theme.spacing(2, 2, 0),
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.divider,
  },
  list: {
    margin: theme.spacing(1.5, -2, 1.5),
  },
  link: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));
